<!-- 移动端主视图 -->
<template>
  <div class="mobile-container" v-if="isWeChatBrowser">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover">
    <!-- Vant 导航栏 -->
    <!-- <van-nav-bar 
      title="VR 消防通" 
      left-arrow
      @click-left="$router.back()"
    /> -->

    <!-- 轮播区域 -->
    <!-- <van-swipe :autoplay="3000">
      <van-swipe-item v-for="item in carouselData" :key="item.id">
        <img :src="item.image" />
      </van-swipe-item>
    </van-swipe> -->

    <!-- 内容区 -->
     <main>
       <router-view />
     </main>
   

    <!-- Vant Tabbar -->
    <van-tabbar v-model="activeTab" class="van-tabbar" v-if="$route.path === '/'||$route.path === '/purchase'||$route.path === '/profilepage'">
      <van-tabbar-item to="/"  >
        <template >
          <img 
            :src="isHome ? '/static/mobile/img/button/底部图标-首页2.png' : '/static/mobile/img/button/底部图标-首页1.png'" 
            class="tabbar-icon"
          >
          <span :style="{ color: isHome ? '#1989fa' : '#646566' }">
            首页
          </span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/purchase" v-if="is_purchase_enabled">
        <template >
          <img 
            :src="isPurchase ? '/static/mobile/img/button/底部图标-已购资源2.png' : '/static/mobile/img/button/底部图标-已购资源1.png'" 
            class="tabbar-icon"
          >
          <span :style="{ color: isPurchase ? '#1989fa' : '#646566' }">
            资源购买
          </span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/profilepage">
        <template >
          <img 
            :src="isProfilePage ? '/static/mobile/img/button/底部图标-我的2.png' : '/static/mobile/img/button/底部图标-我的1.png'" 
            class="tabbar-icon"
          >
          <span :style="{ color: isProfilePage ? '#1989fa' : '#646566' }">
            我的
          </span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
   <div v-else class="wechat-warning">
      <div class="warning-content">
        <h2>请在微信浏览器中打开此页面</h2>
        <p>当前软件不支持访问</p>
      </div>
    </div>
</template>

<script>
import { checkAccessToken } from '@/api/userMG';
export default {
  data() {
    return {
      activeTab: 0,
      isWeChatBrowser: true,
      deviceType:localStorage.getItem('deviceType'),
      key:sessionStorage.getItem('key'),
      is_purchase_enabled:false,
    }
  },
  computed: {
     isHome(){
         return this.$route.path === '/' || this.$route.name === 'index'
      },
      isPurchase(){
        return this.$route.path.startsWith('/purchase');
      },
      isProfilePage(){
        return this.$route.path.startsWith('/profilepage');  
      }
  },
   watch: {
     $route: {
      handler(to) {
        // 根据当前路由动态设置 activeTab 的值
        if (to.path === '/' || to.name === 'index') {
          this.activeTab = 0;
        } else if (to.path.startsWith('/purchase')) {
          this.activeTab = 1;
        } else if (to.path.startsWith('/profilepage')) {
          this.activeTab = 2;
        }
      },
      immediate: true
    },
    '$store.state.HomeInfo': {
      handler(newVal) {
        if (newVal) {
          if (newVal && Object.keys(newVal).length > 0) {
            document.title = newVal.website_name;
            console.log('HomeInfo数据已更新获取到的title', newVal.website_name);
            if (newVal.website_icon) {
              const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.rel = 'icon';
              link.href = newVal.website_icon;
              document.head.appendChild(link);
            }
            this.is_purchase_enabled=newVal.is_purchase_enabled;
            this.$store.state.logimg=newVal.logoImg;
            this.Carousellist= {
              "Carousellist":newVal.Carousellist,
            };
            console.log('index里的HomeInfo数据已更新', newVal)
          }else{
            console.log('index里的HomeInfo数据为空', newVal)
          }
        }
      },
      immediate: true // 立即执行一次
    }
  },
  mounted() {
     // 只有移动设备才需要检查微信浏览器
    if(this.getDeviceType() === 'wechat') {
      this.checkWeChatBrowser();
    }
  
  },
  methods: { 
    checkWeChatBrowser() {
      const ua = window.navigator.userAgent.toLowerCase();
      this.isWeChatBrowser = /micromessenger/.test(ua);
      if(!this.isWeChatBrowser) {
        this.$message.error('请在微信浏览器中打开此页面');
      }else{
        this.getWechatToken();
      }
    },
  getDeviceType() {
      const userAgent = navigator.userAgent;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
        return 'wechat';
      } else {
        return 'computer';
      }
  },
  getWechatToken() {
     let currentRoute = this.$route.path;
     console.log('初始化当前路由1',currentRoute)
    const atoken=localStorage.getItem('accesstoken');
    const opdid=localStorage.getItem('openid');
    // alert('初始化获取本地openid:'+opdid+'\n获取本地accesstoken:'+atoken)
    if(atoken&&opdid){
      checkAccessToken(atoken,opdid).then(res => {
        if (res.code === 201) {
          if(res.weblogin.code===201){
              console.log('获取用户信息',res.weblogin)
              sessionStorage.setItem('name', res.weblogin.data.name);
              sessionStorage.setItem('phone', res.weblogin.data.username);
              sessionStorage.setItem('role',res.weblogin.data.Identitypermissions);
              const redirectPath = this.$route.path;
              if (this.$route.path !== redirectPath) {
                this.$router.push(redirectPath);
              }
              this.$toast.success('登录成功');
          }else{
            this.$toast(res.weblogin.message);
          }
          if(res.weblogin.data.new_acess_token){
             console.log('获取到更新的accesstoken:',res.weblogin.data.new_acess_token)
            localStorage.setItem('accesstoken', res.weblogin.data.new_acess_token);
          }
        } else {
          // this.$toast(res.message);
          console.log('获取用户信息失败',res.weblogin)
        }
      })
    }else{
      console.log('初始化获取本地openid和accesstoken为空,说明在登录页 ')
      //this.$router.push('/login');
       let currentRoute = this.$route.path;
      // let  name=this.$route.name
      console.log('初始化当前路由2',currentRoute)
      // if (this.$route.path === '/login') {
      //   alert('当前处于登录页面，等待用户登录当前路由'+currentRoute+name);
      // } else {
      //    alert('用户未登录且不在登录页面，即将跳转至登录页当前路由'+currentRoute+name);
      //  // this.$router.push('/login');
       
      // }
    }
  },
  },
  
  
}
</script>

<style scoped>
html, body {
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
.mobile-container {
  max-width: 100vw;
  overflow-x: hidden;
}

.van-swipe {
  height: 200px;
}

.van-swipe img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.van-tabbar {
  height: 10vh;
  z-index: 99999;
}

.van-tabbar .van-tabbar-item {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* 确保文本居中 */
}

.tabbar-icon {
  width: 25px; 
  height: 25px;  
  margin-bottom: 1vh;
}

.van-tabbar-item span {
  font-size: 14px;
  line-height: 1;
  display: block;
  margin-top: 1vh;
}

.van-tabbar-item .tabbar-icon{
  display: block;
  margin: 0 auto; /* 水平居中 */
}

/* 手机 端样式 */
.wechat-warning {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}
.warning-content {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.warning-content h2 {
  color: #f56c6c;
  margin-bottom: 15px;
}

</style>